<template>
  <Transition name="SlideRightFade">
    <button
      v-if="showFAB"
      class="fixed bottom-10 right-6 z-30 size-[50px] cursor-pointer select-none rounded-full bg-white shadow-arrowButton hover:bg-lightGray hover:shadow-arrowButtonHover"
      :title="$t('navigation.scroll_to_top')"
      :aria-label="$t('navigation.scroll_to_top')"
      @click="scrollToTop"
    >
      <svg
        width="14"
        height="17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="inline-block"
      >
        <path
          d="M13.159 6.952 7.079 1 1 6.952M7.08 1.524V17"
          stroke="#000"
          stroke-width=".794"
        />
      </svg>
    </button>
  </Transition>
</template>

<script lang="ts">
import { useDebounceFn } from '@vueuse/core'

export default defineComponent({
  name: 'FAB',
  setup() {
    const showFAB = ref<boolean | null>(null)
    let lastScrollTop = 0

    onMounted(onScrollDown)
    useEventListener('scroll', useDebounceFn(onScrollDown, 10))
    useEventListener('scroll', useDebounceFn(onScrollStop, 300))

    function onScrollStop() {
      showFAB.value = window.pageYOffset > window.innerHeight
    }

    function onScrollDown() {
      if (window.pageYOffset < window.innerHeight) {
        showFAB.value = false
        return
      }
      const scrollTop = document?.documentElement?.scrollTop
      const diff = scrollTop - lastScrollTop
      showFAB.value = diff < 0
      lastScrollTop = scrollTop
    }

    function scrollToTop(): void {
      window.scrollTo({ top: 0 })
    }

    return {
      showFAB,
      scrollToTop,
    }
  },
})
</script>
